import { GatewayContaTab } from './GatewayContaTab'
import layoutStyles from '@/layouts/TabsLayout/TabsLayout.module.css'
import { CampaignTotpStepUpProvider } from '@/contexts/CampaignTotpStepUpContext'
import { CampaignTotpStepUpGate } from '@/components/CampaignTotpStepUp'

export function GatewayPagamentoPage() {
  return (
    <CampaignTotpStepUpProvider>
      <CampaignTotpStepUpGate fallbackTo="/">
        <div className={layoutStyles.page}>
          <div className={layoutStyles.header}>
            <div className={layoutStyles.headerText}>
              <h1 className={layoutStyles.title}>Gateway de pagamento</h1>
              <p className={layoutStyles.subtitle}>
                Configure e gerencie integrações com gateways de pagamento
              </p>
            </div>
          </div>

          <div className={layoutStyles.content}>
            <GatewayContaTab />
          </div>
        </div>
      </CampaignTotpStepUpGate>
    </CampaignTotpStepUpProvider>
  )
}
